import React from "react";

class ContainerComponents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            isMobil: true,
        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize() {
        const BREAKPOINT_MOBIL = 768;

        this.setState({
            ...this.state,
            isMobil: window.innerWidth <= BREAKPOINT_MOBIL,
        });
    }

    render() {
        return (
            <div
                className={`${this.state.isMobil ? "main-container" : ""} ${this.props.authoring.class || ''} ${this.props.authoring.aditionalClass || ''}`}
            >
                {this.props.children}
            </div>
        );
    }
}

export default ContainerComponents;
